import { render, staticRenderFns } from "./SoldPerBuyerTable.vue?vue&type=template&id=1c058a23&"
import script from "./SoldPerBuyerTable.vue?vue&type=script&lang=js&"
export * from "./SoldPerBuyerTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports